/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zxx
 * @Date: 2023-07-26 10:18:14
 * @LastEditTime: 2023-08-30 10:11:10
 */
/* eslint-disable */
/**
 * method命名规则
 * 取url中个性命名部分，使用大写驼峰进行组合，禁止个性化自定义名称，避免该配置文件丢失后，无法找回使用的方法名
 * 如：/api/v1/basic/data，/api/v1/为公共部分，取basic/data组成 BasicData
 */
module.exports = {
  apiConfig: [
    {
      name: '可视化',
      method: 'StatisticsVisualization',
      url: '/api/v1/statistics/visualization',
      type: 'get'
    },
    {
      name: '预报数据',
      method: 'ForecastData',
      url: '/api/v1/data/forecastDeatil',
      type: 'post'
    },
    {
      name: '美丽渔村',
      method: 'FishData',
      url: '/api/v1/website/fish',
      type: 'post'
    },
    {
      name: '海洋科普',
      method: 'OceanData',
      url: '/api/v1/website/ocean',
      type: 'post'
    },
    {
      name: '海洋科普详情',
      method: 'OceanDetailData',
      url: '/api/v1/data/OceanDetailData',
      type: 'post'
    },
    {
      name: '告警栏',
      method: 'NoticeData',
      url: '/api/v1/website/notice/data',
      type: 'post'
    },
    {
      name: '获取各类型数据对应关系',
      method: 'WebsiteRelation',
      url: '/api/v1/website/relation',
      type: 'get'
    },
    {
      name: '获取浪温预报数据',
      method: 'WebsiteForecast',
      url: '/api/v1/website/forecast',
      type: 'get'
    },
    {
      name: '获取今日浪温预报数据',
      method: 'WebsiteForecastToday',
      url: '/api/v1/website/forecast/today',
      type: 'get'
    },
    {
      name: '获取json数据',
      method: 'GetJson',
      url: '/api/v1/website/json',
      type: 'get'
    },
    {
      name: '查询各类型文件记录',
      method: 'RecordPage',
      url: '/api/v1/file/record/page',
      type: 'POST'
    },
    {
      name: '获取详情',
      method: 'RecordDetail',
      url: '/api/v1/file/record/detail',
      type: 'GET'
    },
    {
      name: '查询时效内的灾害警报',
      method: 'DisasterLimit',
      url: '/api/v1/file/record/disaster/limit',
      type: 'POST'
    },
    {
      name: '潮汐预报',
      method: 'GuideTide',
      url: '/api/v1/guide/tide',
      type: 'GET'
    },
    {
      name: '获取云图',
      method: 'ImagesRealtime',
      url: '/ladeapi/bus/api/v1/images/realtime',
      type: 'GET'
    },
    {
      name: '浮标列表',
      method: 'StationAggregate',
      url: '/bus/api/v1/station/aggregate',
      type: 'get'
    },
    {
      name: '浮标详情',
      method: 'AggregateInfo',
      url: '/bus/api/v1/station/aggregate/info',
      type: 'get'
    },
    {
      name: '福建省海洋预报台渔场预报数据',
      method: 'FisheryAgingFj',
      url: '/api/v1/guide/fishery/aging/fj',
      type: 'get'
    },
    {
      name: '宁德海洋中心预报数据',
      method: 'FtForecastNumber',
      url: '/forecast/FtForecastNumber.json',
      type: 'get'
    },
    {
      name: '文件浏览点击',
      method: 'FileRecordClickCount',
      url: '/api/v1/file/record/click/count',
      type: 'post'
    },
    {
      name: '获取友情连接',
      method: 'LinksList',
      url: '/bus/api/v1/links/list',
      type: 'get'
    },
    {
      name: '获取零点换算85高程基准',
      method: 'WebsiteStandard',
      url: '/api/v1/website/standard',
      type: 'get'
    }
  ]
}
